/**
 * @generated SignedSource<<e337f717edf3a56d1f5ea5cf11e70351>>
 * @relayHash f92e27702d301c1d43584021ee4e7659
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 937eee75e4d66d9609260fa7560823272c7cfe59f822338580e01f94953bd683

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewMainQuery$variables = {
  cloudId: string;
  projectLevelReportingEnabled: boolean;
  schemaMigrationEnabled: boolean;
  siteOptimizerAddCfoIslMetricsEnabled: boolean;
};
export type PerformanceOverviewMainQuery$data = {
  readonly jira: {
    readonly resourceUsageMetrics?: {
      readonly " $fragmentSpreads": FragmentRefs<"OverviewPage">;
    };
    readonly resourceUsageMetricsV2?: {
      readonly overviewPageV2SchemaMigrationData?: {
        readonly " $fragmentSpreads": FragmentRefs<"OverviewPageV2SchemaMigrationData">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"OverviewPage843BadPattern">;
    };
  };
};
export type PerformanceOverviewMainQuery = {
  response: PerformanceOverviewMainQuery$data;
  variables: PerformanceOverviewMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectLevelReportingEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemaMigrationEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteOptimizerAddCfoIslMetricsEnabled"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "projectLevelReportingEnabled",
    "variableName": "projectLevelReportingEnabled"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "currentValue"
},
v8 = {
  "kind": "ScalarField",
  "name": "warningValue"
},
v9 = {
  "kind": "ScalarField",
  "name": "thresholdValue"
},
v10 = {
  "kind": "ScalarField",
  "name": "cleanupValue"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "ScalarField",
  "name": "projectsOverLimit"
},
v13 = {
  "kind": "ScalarField",
  "name": "projectsReachingLimit"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = [
  (v12/*: any*/),
  (v13/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "JiraWorkTypeUsageMetric"
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "JiraCustomFieldUsageMetric"
},
v18 = [
  {
    "kind": "ScalarField",
    "name": "schemesOverLimit"
  },
  {
    "kind": "ScalarField",
    "name": "schemesReachingLimit"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PerformanceOverviewMainQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "schemaMigrationEnabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraResourceUsageMetricConnection",
                    "kind": "LinkedField",
                    "name": "resourceUsageMetrics",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "OverviewPage"
                      }
                    ]
                  },
                  "action": "THROW"
                }
              ]
            },
            {
              "condition": "schemaMigrationEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                    "kind": "LinkedField",
                    "name": "resourceUsageMetricsV2",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "OverviewPage843BadPattern"
                      },
                      {
                        "condition": "siteOptimizerAddCfoIslMetricsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "fragment": {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "FragmentSpread",
                                  "name": "OverviewPageV2SchemaMigrationData"
                                }
                              ],
                              "type": "JiraResourceUsageMetricConnectionV2"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "overviewPageV2SchemaMigrationData"
                          }
                        ]
                      }
                    ]
                  },
                  "action": "THROW"
                }
              ]
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "PerformanceOverviewMainQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "schemaMigrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraResourceUsageMetricConnection",
                "kind": "LinkedField",
                "name": "resourceUsageMetrics",
                "plural": false,
                "selections": [
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "concreteType": "JiraResourceUsageMetric",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraResourceUsageMetric",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "schemaMigrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraResourceUsageMetricConnectionV2",
                "kind": "LinkedField",
                "name": "resourceUsageMetricsV2",
                "plural": false,
                "selections": [
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "projectLevelReportingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "siteOptimizerAddCfoIslMetricsEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "fieldsOverLimit"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "fieldsReachingLimit"
                              }
                            ],
                            "type": "JiraCustomFieldOptionUsageMetric"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v15/*: any*/),
                            "type": "JiraIssueSecurityLevelUsageMetric"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v18/*: any*/),
                            "type": "JiraPermissionGrantUsageMetric"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v18/*: any*/),
                            "type": "JiraWorkflowResourceUsageMetric"
                          },
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "937eee75e4d66d9609260fa7560823272c7cfe59f822338580e01f94953bd683",
    "metadata": {},
    "name": "PerformanceOverviewMainQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5daa69147986dcb6c0bed5d352f2f492";

export default node;
